import React from "react";
import "../components/footer.css";

const Profile = () => {
  return <div></div>;
};

export default Profile;
